import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import { Auth0Provider } from '@auth0/auth0-react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import './index.css';
import App from './App';
import { store } from './store';
import * as serviceWorker from './serviceWorker';
import { auth0Domain, auth0ClientId, auth0Audience } from './config';
import theme from './config/theme';
import { hideMaterialTableExportPdf } from './utils/tables';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Auth0Provider
              domain={auth0Domain}
              clientId={auth0ClientId}
              audience={auth0Audience}
              redirectUri={window.location.origin}
            >
              <App />
            </Auth0Provider>
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

hideMaterialTableExportPdf();
